<script setup lang="ts">
import type { TimeslotSettings } from '@sub/utils/getCompanySettings';

const props = withDefaults(defineProps<{
  text?: string;
  price?: string;
  active?: boolean;
  disabled?: boolean;
  timeslotSettings?: TimeslotSettings;
}>(), {
  text: '',
  price: '',
  active: false,
  disabled: false,
  timeslotSettings: () => ({}),
});

const { activeBackground, activeColor, hoverBackground, showPrice } = props.timeslotSettings;
</script>

<template lang="pug">
.flex.col-4
  button.time-slot.flex-center-center.typ-13-17-400.br-12.white-space-nowrap(type="button" :disabled="disabled" :class="{active}")
    | {{ text }}
  .price.flex-center-center.typ-11-14-500(v-if="showPrice && price && !disabled") {{ price }}
</template>

<style scoped lang="scss">
@use "@ui/styles/scss/animations" as *;

.price {
  color: #818D98;
}

.time-slot {
  border: 1px solid #B0B2C0;
  color: #1F1F1F;
  background: #FFFFFF;
  cursor: pointer;

  --uno: p-12-2;

  @screen sm {
    --uno: p-16-6;
  }

  &:disabled {
    background: #F8F8F9;
    color: #ABB1B6;
    border-color: transparent;
    cursor: not-allowed;
  }

  &:not(:disabled) {
    &:not(.active):hover {
      border-color: #5B646D;
      background: v-bind(hoverBackground);
    }

    &:active {
      @include click-animation;
    }
  }

  &.active {
    color: v-bind(activeColor);
    background: v-bind(activeBackground);
    border-color: transparent;
  }
}
</style>